import {FaUserAlt} from 'react-icons/fa'
import {useLoginViaAuthWindow} from '@helpers/auth/loginViaAuth'

function LoginButton() {
  const loginViaAuth = useLoginViaAuthWindow('navbar')
  return (
    <a
      onClick={() => loginViaAuth()}
      className="flex items-center justify-center cursor-pointer font-bold text-normal text-inherit px-3 w-fit whitespace-nowrap mx-auto">
      <span className="lg:hidden">
        <FaUserAlt />
      </span>
      <span className="hidden lg:block">Iniciar sesión</span>
    </a>
  )
}

export default LoginButton
